'use client'

import { useSyncExternalStore } from 'react'
import {
  getMarketingConsent,
  subscribeMarketingConsent,
  type MarketingConsentState,
} from '@/utils/ads/marketing-consent'

const getServerSnapshot = (): MarketingConsentState => 'unknown'

export const useMarketingConsent = (): MarketingConsentState =>
  useSyncExternalStore(
    subscribeMarketingConsent,
    getMarketingConsent,
    getServerSnapshot
  )
